import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-prev.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-next.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-577cb486")

_pushScopeId("data-v-577cb486")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text-12px self-center"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "flex flex-row w-32" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  class: "h-4 mx-auto"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  class: "h-4 mx-auto"
}, null, -1)
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { class: "text-14px self-center" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_11 = { class: "font-semibold" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { class: "flex flex-row gap-x-4 text-14px items-center" }
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  class: "h-4 mx-auto"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  class: "h-4 mx-auto"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: 
      `flex flex-row space-x-4 py-6 bottom-0 z-10 right-0 pr-8 ${_ctx.paginationWidth} ${
        _ctx.isShowCaption ? 'justify-between' : 'justify-end'
      } bg-white`
    
  }, [
    (_ctx.paginationStyle === 'v1')
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.totalData === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_1))
            : (_ctx.totalData && _ctx.isShowCaption)
              ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("showingPagination")) + " 1 - " + _toDisplayString(_ctx.totalData) + " Data ", 1))
              : _createCommentVNode("", true),
          (_ctx.isShowCaption && _ctx.isThereIsBottonWidget)
            ? (_openBlock(), _createBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_4, [
            _createVNode("button", {
              class: "border h-8 w-1/2 focus:outline-none rounded-l-md",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPrevious()))
            }, [
              _hoisted_5
            ]),
            _createVNode("input", {
              type: "text",
              placeholder: _ctx.page,
              value: _ctx.defaultValue,
              class: "w-1/2 h-8 text-center placeholder-custom-100 border font-montserrat focus:outline-none",
              onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToPage && _ctx.goToPage(...args)))
            }, null, 40, ["placeholder", "value"]),
            _withDirectives(_createVNode("button", {
              class: "border h-8 w-1/2 focus:outline-none rounded-r-md",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onNext()))
            }, [
              _hoisted_6
            ], 512), [
              [_vShow, _ctx.isButtonNext]
            ])
          ]),
          (_ctx.isShowCaption && _ctx.isThereIsBottonWidget)
            ? (_openBlock(), _createBlock("div", _hoisted_7))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.paginationStyle === 'v2')
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.$t("Menampilkan")) + " ", 1),
            _createVNode("span", _hoisted_9, _toDisplayString(_ctx.first), 1),
            _hoisted_10,
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.last), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("data dari total")) + " ", 1),
            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.totalData), 1)
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("button", {
              class: "focus:outline-none",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPrevious()))
            }, [
              _hoisted_14
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availablePage, (index) => {
              return (_openBlock(), _createBlock("button", {
                key: index,
                class: ["focus:outline-none font-medium", `${_ctx.page === index && 'page-active'}`],
                onClick: ($event: any) => (_ctx.toPage(index))
              }, _toDisplayString(index), 11, ["onClick"]))
            }), 128)),
            _createVNode("button", {
              class: "focus:outline-none",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onNext()))
            }, [
              _hoisted_15
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
})